import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { getAppStore } from '../../AppStore';
import { BreadcrumbStateInfo } from '../../content/breadcrumbs/BreadcrumbStateInfo';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedAllGroupsSpace } from './ConnectedAllGroupsSpace';

export interface AllGroupsSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const groupsSpaceInfo: SpaceInfo = { spaceType: 'groups', subspaceName: undefined, item: SpaceItemForNonEntitySpace };

export const AllGroupsSpaceProvider: React.FunctionComponent<AllGroupsSpaceProviderProps> = (props) => {

  React.useEffect(() => {
    getAppStore().dispatch(updateBreadcrumbs([getGroupsPlaceBreadcrumb(props.urls)]));
  }, []);

  return (
    <ConnectedSpaceInfoProvider spaceInfo={groupsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllGroupsSpace
          angularContext={props.angularContext}
          siteName={props.siteName}
        />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getGroupsPlaceBreadcrumb(urls: SpacesSiteUrls): BreadcrumbStateInfo {
  const href = urls.groupsUrl();
  return {
    id: href,
    text: Messages.allGroups(),
    href: href,
    testId: 'groups-link'
  };
}
